import Vue from 'vue'
import Router from 'vue-router'


// 导入商品路由配置
import RouterConfig from './route_config.js';

Vue.use(Router)

const router = new Router({
    //mode: 'history',
    mode: 'hash',
    //base: '/CywMobile/',
    routes: RouterConfig
})

router.beforeEach((to, from, next) => {

    //console.log('导出路由守卫函数');
    //console.log(to);
    let toPage = to.name;
    //console.log(toPage);
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "车盈网";
    }

    next();

    let expireTime = window.localStorage.getItem('expireTime');
    let adminInfo = window.localStorage.getItem('adminInfo');
    let adminParams = window.localStorage.getItem('adminParams');
    //console.log(expireTime);
    //console.log(adminInfo);
    // 去往登录
    if (toPage == 'Login') {
        //console.log('去往登录');
        if (expireTime && adminParams && adminInfo && (expireTime - new Date().getTime()) > 0) {
            //console.log('转主页');
            next('/'); // 主页
        } else {
            next(); // 转登录
            return;
        }
    }
    // 去往非登录
    if (toPage != 'Login') {
        //console.log('去往非登录');
        //console.log(expireTime);
        if (expireTime && adminInfo && adminParams && (expireTime - new Date().getTime()) > 0) {
            window.localStorage.setItem("expireTime", new Date().getTime() + 604800000);
            next(); // 允许访问
        } else {
            // 检票页 / 下车点售票详情：司机端 WebView 带参进入，允许未登录访问
            if (
                (toPage == 'TicketCheck' || toPage == 'NodeTicketList') &&
                JSON.stringify(to.query) != "{}"
            ) {
                //console.log(to.query)
                next(); // 允许访问
                return
            }
            //console.log('转登录');
            next('/login'); // 转登录
            return;
        }
    }
    //去往站务管理
    // if (toPage == 'LineClassDay') {

    // }
});

export default router